import React from 'react';
import { Link } from 'react-router-dom';

const PageHeader = ({ title, breadcrumb }) => {
  return (
    <div className="page-header">
      <div className="container">
        <h1 className="fade-in">{title}</h1>
        {breadcrumb && (
          <p className="breadcrumb fade-in delay-1">
            <Link to="/">Home</Link> / {breadcrumb}
          </p>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
